/* LUCRÜ™ — © 2026 LUCRÜ. All rights reserved. */
import React from "react";

/**
 * LUCRÜ brand logo. Uses the user-supplied hand-drawn spiral.
 * Renders white on dark backgrounds. `tone="dark"` for use on light surfaces.
 */
const Logo = ({ size = 32, tone = "light", className = "", withBackground = false }) => {
  const src = tone === "dark" ? "/logo-black.png" : "/logo-white.png";

  if (withBackground) {
    return (
      <div
        className={`relative inline-flex items-center justify-center rounded-xl bg-gradient-to-br from-[#00E5FF] to-[#39FF14] ${className}`}
        style={{ width: size, height: size }}
      >
        <img
          src="/logo-black.png"
          alt="LUCRÜ"
          style={{ width: size * 0.74, height: size * 0.74, objectFit: "contain" }}
          draggable={false}
        />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt="LUCRÜ"
      className={className}
      style={{ width: size, height: size, objectFit: "contain" }}
      draggable={false}
    />
  );
};

export default Logo;
